import request from '@/config/axios'

export interface LiveRelayVO {
  id?: number
  liveId?: number
  sellerUserId?: number
  title?: string
  price?: number
  status?: number
}

export const pageRelay = (params: any) => request.get({ url: '/live/relay/page', params })
export const getRelay = (id: number) =>
  request.get({ url: '/live/relay/get', params: { id } })
export const createRelay = (data: LiveRelayVO) =>
  request.post({ url: '/live/relay/create', data })
export const updateRelay = (data: LiveRelayVO) =>
  request.put({ url: '/live/relay/update', data })
export const deleteRelay = (id: number) =>
  request.delete({ url: '/live/relay/delete', params: { id } })
